import { render } from "./consentradiogroup.vue?vue&type=template&id=47d7f698&scoped=true"
import script from "./consentradiogroup.vue?vue&type=script&lang=js"
export * from "./consentradiogroup.vue?vue&type=script&lang=js"

import "./consentradiogroup.vue?vue&type=style&index=0&id=47d7f698&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d7f698"]])

export default __exports__